import { Texture2D } from "../../../../resource/Texture2D";
import { CommandBuffer } from "../command/CommandBuffer";
import { Shader3D } from "../../../../RenderEngine/RenderShader/Shader3D";
import { RenderTargetFormat } from "../../../../RenderEngine/RenderEnum/RenderTargetFormat";
import { DepthTextureMode, RenderTexture } from "../../../../resource/RenderTexture";
import { LayaGL } from "../../../../layagl/LayaGL";
import { PostProcessRenderContext } from "./PostProcessRenderContext";
import { ColorGradEffect } from "../../../postProcessEffect/ColorGradEffect";
export class PostProcess {
    static __init__() {
        PostProcess.SHADERDEFINE_BLOOM_LOW = Shader3D.getDefineByName("BLOOM_LOW");
        PostProcess.SHADERDEFINE_BLOOM = Shader3D.getDefineByName("BLOOM");
        PostProcess.SHADERDEFINE_FINALPASS = Shader3D.getDefineByName("FINALPASS");
        PostProcess.SHADERVALUE_MAINTEX = Shader3D.propertyNameToID("u_MainTex");
        PostProcess.SHADERVALUE_BLOOMTEX = Shader3D.propertyNameToID("u_BloomTex");
        PostProcess.SHADERVALUE_AUTOEXPOSURETEX = Shader3D.propertyNameToID("u_AutoExposureTex");
        PostProcess.SHADERVALUE_BLOOM_DIRTTEX = Shader3D.propertyNameToID("u_Bloom_DirtTex");
        PostProcess.SHADERVALUE_BLOOMTEX_TEXELSIZE = Shader3D.propertyNameToID("u_BloomTex_TexelSize");
        PostProcess.SHADERVALUE_BLOOM_DIRTTILEOFFSET = Shader3D.propertyNameToID("u_Bloom_DirtTileOffset");
        PostProcess.SHADERVALUE_BLOOM_SETTINGS = Shader3D.propertyNameToID("u_Bloom_Settings");
        PostProcess.SHADERVALUE_BLOOM_COLOR = Shader3D.propertyNameToID("u_Bloom_Color");
    }
    recaculateCameraFlag() {
        this._depthtextureFlag = DepthTextureMode.None;
        let n = this.effects.length;
        for (let i = 0; i < n; i++) {
            this._depthtextureFlag |= this.effects[i].getCameraDepthTextureModeFlag();
        }
    }
    constructor() {
        this._effects = [];
        this._enable = true;
        this._enableColorGrad = false;
        this._context = new PostProcessRenderContext();
        this._context.compositeShaderData = this._compositeShaderData = LayaGL.renderDeviceFactory.createShaderData(null);
        this._context.command = new CommandBuffer();
        this._depthtextureFlag = 0;
    }
    get enable() {
        return this._enable;
    }
    set enable(value) {
        this._enable = value;
    }
    set commandContext(oriContext) {
        this._context.command._context = oriContext;
    }
    get effects() {
        return this._effects;
    }
    set effects(value) {
        this.clearEffect();
        for (var i = 0, n = value.length; i < n; i++) {
            if (value[i])
                this.addEffect(value[i]);
        }
    }
    get cameraDepthTextureMode() {
        return this._depthtextureFlag;
    }
    _init(camera) {
        this._context.camera = camera;
        this._context.command._camera = camera;
    }
    _render(camera) {
        this._init(camera);
        let context = this._context;
        var camera = context.camera;
        var viewport = camera.viewport;
        var internalRT = camera._needInternalRenderTexture();
        var cameraTarget = !internalRT ? RenderTexture.createFromPool(camera._offScreenRenderTexture.width, camera._offScreenRenderTexture.height, camera._getRenderTextureFormat(), RenderTargetFormat.None, false, 1, false, true) : camera._internalRenderTexture;
        var screenTexture = RenderTexture.createFromPool(cameraTarget.width, cameraTarget.height, camera._getRenderTextureFormat(), RenderTargetFormat.None, false, 1, false, true);
        var Indirect = [
            RenderTexture.createFromPool(cameraTarget.width, cameraTarget.height, camera._getRenderTextureFormat(), RenderTargetFormat.None, false, 1, false, true),
            RenderTexture.createFromPool(cameraTarget.width, cameraTarget.height, camera._getRenderTextureFormat(), RenderTargetFormat.None, false, 1, false, true)
        ];
        context.command.clear();
        context.source = screenTexture;
        context.indirectTarget = screenTexture;
        context.destination = this._effects.length == 2 ? Indirect[0] : cameraTarget;
        context.compositeShaderData.clearDefine();
        if (internalRT) {
            context.command.blitScreenTriangle(camera._internalRenderTexture, screenTexture);
        }
        else {
            context.command.blitScreenTriangle(camera._offScreenRenderTexture, screenTexture);
        }
        context.compositeShaderData.setTexture(PostProcess.SHADERVALUE_AUTOEXPOSURETEX, Texture2D.whiteTexture);
        if (this._enableColorGrad) {
            this._ColorGradEffect._buildLUT();
        }
        for (let i = 0, n = this._effects.length; i < n; i++) {
            if (this._effects[i].active) {
                this._effects[i].render(context);
                if (i === n - 2) {
                    context.indirectTarget = context.destination;
                    context.destination = cameraTarget;
                }
                else {
                    context.indirectTarget = context.destination;
                    context.destination = Indirect[(i + 1) % 2];
                }
            }
            else if (i === n - 1) {
                context.command.blitScreenTriangle(context.indirectTarget, cameraTarget);
            }
        }
        this._compositeShaderData.addDefine(PostProcess.SHADERDEFINE_FINALPASS);
        if (camera._offScreenRenderTexture) {
            if (internalRT) {
                context.destination = camera._offScreenRenderTexture;
                var canvasWidth = camera._getCanvasWidth(), canvasHeight = camera._getCanvasHeight();
                if (LayaGL.renderEngine._screenInvertY) {
                    camera._screenOffsetScale.setValue(viewport.x / canvasWidth, viewport.y / canvasHeight, viewport.width / canvasWidth, viewport.height / canvasHeight);
                }
                else {
                    camera._screenOffsetScale.setValue(viewport.x / canvasWidth, 1.0 - viewport.y / canvasHeight, viewport.width / canvasWidth, -viewport.height / canvasHeight);
                }
                context.command.blitScreenTriangle(cameraTarget, camera._offScreenRenderTexture, camera._screenOffsetScale, null, this._compositeShaderData, 0);
            }
        }
        if (internalRT)
            RenderTexture.recoverToPool(cameraTarget);
        RenderTexture.recoverToPool(screenTexture);
        RenderTexture.recoverToPool(Indirect[0]);
        RenderTexture.recoverToPool(Indirect[1]);
        var tempRenderTextures = context.deferredReleaseTextures;
        for (let i = 0, n = tempRenderTextures.length; i < n; i++)
            RenderTexture.recoverToPool(tempRenderTextures[i]);
        tempRenderTextures.length = 0;
    }
    addEffect(effect) {
        if (effect.singleton && this.getEffect(effect.constructor)) {
            console.error("the target effect is a singleton", effect);
            return null;
        }
        if (!this._enableColorGrad || effect instanceof ColorGradEffect) {
            this._effects.push(effect);
        }
        else {
            this._effects.splice(this._effects.length - 1, 0, effect);
        }
        this.recaculateCameraFlag();
        effect.effectInit(this);
        return effect;
    }
    getEffect(classReg) {
        return this._effects.find(effect => effect instanceof classReg) || null;
    }
    removeEffect(effect) {
        var index = this._effects.indexOf(effect);
        if (index !== -1) {
            this._effects.splice(index, 1);
            effect.release(this);
            this.recaculateCameraFlag();
        }
    }
    clearEffect() {
        let i = this.effects.length - 1;
        for (; i >= 0; i--) {
            this.removeEffect(this.effects[i]);
        }
        this._effects.length = 0;
    }
    _applyPostProcessCommandBuffers() {
        this._context.command._apply();
    }
}
